import { render } from "./AddDishModalComponent.vue?vue&type=template&id=3eda54ba&scoped=true"
import script from "./AddDishModalComponent.vue?vue&type=script&lang=js"
export * from "./AddDishModalComponent.vue?vue&type=script&lang=js"

import "./AddDishModalComponent.vue?vue&type=style&index=0&id=3eda54ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eda54ba"]])

export default __exports__